import script from "./UserEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserEditDialog.vue?vue&type=style&index=0&id=dba6d828&scoped=true&lang=css"
import "./UserEditDialog.vue?vue&type=style&index=1&id=dba6d828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dba6d828"]])

export default __exports__